export class SoapCountdown {
    constructor() {
        this.init();
    }

    init() {
        // Obtenemos todos los contadores de la página
        let countdown = $('#countdownEvt');
        if (!countdown.length) {
            return;
        }

        // Lo actualizamos cada segundo
        window.setInterval(() => {
            // Fecha de inicio del evento
            let expired = false;

            // Los ponemos en milisegundos para igualarlo con la fecha actual
            let countDownDate = countdown.data('eventdate') * 1000;

            // Feacha actual en milisegundos
            let now = Date.now();

            // Cuanto queda desde hoy
            let distance = countDownDate - now;

            let days = Math.floor(distance / (1000 * 60 * 60 * 24));
            let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            let seconds = Math.floor((distance % (1000 * 60)) / 1000);

            let counterContainer = countdown.find('.countdown--counter');
            let daysContainer = counterContainer.find('.days .number');
            let hoursContainer = counterContainer.find('.hours .number');
            let minutesContainer = counterContainer.find('.minutes .number');
            let secondsContainer = counterContainer.find('.seconds .number');

            if (distance < 0) {
                expired = true;
            }

            if (daysContainer.length) {
                !expired ? daysContainer.text(this.formatNumber(days)) : daysContainer.text("00");
            }

            if (hoursContainer.length) {
                !expired ? hoursContainer.text(this.formatNumber(hours)) : hoursContainer.text("00");
            }

            if (minutesContainer.length) {
                !expired ? minutesContainer.text(this.formatNumber(minutes)) : minutesContainer.text("00");
            }

            if (secondsContainer.length) {
                !expired ? secondsContainer.text(this.formatNumber(seconds)) : secondsContainer.text("00");
            }

            if (expired) {
                countdown.css('display', 'none');
            }
        }, 1000, countdown);
    }

    formatNumber(number) {
        return number.toLocaleString('es-ES', {
            minimumIntegerDigits: 2,
            useGrouping: false
        });
    }
}
